import { useQuery } from "@tanstack/react-query";
import { db } from '@/lib/db';

export interface Sector {
  id: string;
  nome: string;
  nome_exibicao: string;
  tipo: string;
  ordem: number;
  cor_badge: string;
  ativo: boolean;
}

/**
 * Setores que podem receber AÇÃO de retrabalho / aparecer em filtros de fluxo.
 *
 * Exclui ESTOQUE por NOME (denylist), e não por `tipo === 'PRODUCAO'`: ARTE e
 * LOGISTICA têm tipo próprio e SÃO ofertáveis de propósito — filtrar por
 * PRODUCAO mataria o retrabalho de arte, que é a razão de ser da migration 0077.
 *
 * ESTOQUE fica de fora porque é posto de bipagem, não etapa do fluxo: uma ação
 * ali viraria card sem coluna em quadro nenhum, invisível, contando como atraso
 * e travando a conclusão do pedido.
 */
export const SETORES_FORA_DO_FLUXO = ['ESTOQUE'] as const;

export function ehSetorDeFluxo(setor: { nome: string }): boolean {
  return !SETORES_FORA_DO_FLUXO.includes(setor.nome as (typeof SETORES_FORA_DO_FLUXO)[number]);
}

export const useSectors = () => {
  return useQuery({
    queryKey: ['sectors'],
    queryFn: async () => {
      const { data, error } = await db
        .from('sectors')
        .select('*')
        .eq('ativo', true)
        .order('ordem', { ascending: true });

      if (error) {
        console.error('Error fetching sectors:', error);
        throw error;
      }

      return data as Sector[];
    },
    staleTime: 600000, // 10 minutos - permite refresh mais rápido se gerente editar setores
    gcTime: Infinity, // Nunca remove do cache (gcTime substituiu cacheTime no React Query v5)
  });
};
